import React, { ReactNode } from 'react';
import { AppHeader } from '../AppHeader';
import { FOOTER_COPYRIGHT, FOOTER_DISCLAIMER } from '../../constants/footerCopy';
import '../../styles/layout.css';

export interface PageShellProps {
  children: ReactNode;
  className?: string;
  /** Show standard legal footer */
  showFooter?: boolean;
  /** Apply staggered entrance animation */
  animate?: boolean;
  /** Wider main column */
  wide?: boolean;
}

export function PageShell({
  children,
  className = '',
  showFooter = true,
  animate = true,
  wide = false,
}: PageShellProps) {
  const rootClass = [
    'ev-page',
    'ev-page-shell',
    animate ? 'ev-page-enter' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const mainClass = ['ev-shell-main', wide ? 'ev-shell-main--wide' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <div className="ev-animate-in">
        <AppHeader />
      </div>
      <main className={mainClass}>{children}</main>
      {showFooter && (
        <footer className="ev-shell-footer ev-animate-in">
          <p className="ev-shell-footer-copyright">
            {FOOTER_COPYRIGHT.split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i === 0 && <br />}
              </React.Fragment>
            ))}
          </p>
          <p className="ev-shell-footer-disclaimer">{FOOTER_DISCLAIMER}</p>
        </footer>
      )}
    </div>
  );
}

export default PageShell;
